<template>
  <div class="app-admin-page">
    <div class="app-admin-card">
      <div class="toolbar">
        <div>
          <div class="title">WGT 发布管理</div>
          <div class="muted">上传最新 APP 热更新包，APP 启动时会静默下载并在下次重启后生效。</div>
        </div>
        <el-button icon="el-icon-refresh" @click="getList">刷新</el-button>
      </div>

      <el-form :model="form" label-width="110px" class="publish-form">
        <el-form-item label="上传 WGT">
          <el-upload
            action="/api/admin/app/wgt/upload"
            :headers="uploadHeaders"
            :show-file-list="false"
            accept=".wgt"
            :on-success="uploadSuccess"
            :before-upload="beforeUpload"
          >
            <el-button type="primary" icon="el-icon-upload">选择 .wgt 文件</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="版本号">
          <el-input v-model="form.version" placeholder="例如 1.0.1"></el-input>
        </el-form-item>
        <el-form-item label="版本码">
          <el-input-number v-model="form.version_code" :min="1" style="width: 180px"></el-input-number>
          <span class="muted inline-tip">必须大于当前 APP versionCode 才会触发更新</span>
        </el-form-item>
        <el-form-item label="WGT 地址">
          <el-input v-model="form.wgt_url" placeholder="上传后自动填入"></el-input>
        </el-form-item>
        <el-form-item label="文件信息">
          <div class="muted">文件：{{ form.file_name || "-" }}，大小：{{ form.file_size || 0 }} bytes，MD5：{{ form.md5 || "-" }}</div>
        </el-form-item>
        <el-form-item label="发布状态">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="0" active-text="启用为最新版本"></el-switch>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" v-model="form.remark" :rows="3" placeholder="可填写更新说明"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="save">保存发布</el-button>
          <el-button @click="resetForm">清空</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border height="46vh">
        <el-table-column label="版本" width="120">
          <template slot-scope="scope">{{ scope.row.version }}</template>
        </el-table-column>
        <el-table-column label="版本码" width="100" prop="version_code"></el-table-column>
        <el-table-column label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="Number(scope.row.status) === 1 ? 'success' : 'info'">{{ Number(scope.row.status) === 1 ? "启用" : "停用" }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="WGT地址" min-width="260">
          <template slot-scope="scope">
            <el-link :href="scope.row.wgt_url" target="_blank" type="primary">{{ scope.row.wgt_url }}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="160">
          <template slot-scope="scope">{{ formatTime(scope.row.updated_at || scope.row.created_at) }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { post } from "../axios/request.js";
import { formatTime, isSuccess } from "./appAdminUtils.js";

export default {
  name: "appWgt",
  data() {
    return {
      list: [],
      form: this.emptyForm(),
    };
  },
  computed: {
    uploadHeaders() {
      return {
        Authorization: localStorage.getItem("token") || "",
      };
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    formatTime,
    emptyForm() {
      return {
        id: "",
        version: "",
        version_code: 1,
        wgt_url: "",
        file_name: "",
        file_size: 0,
        md5: "",
        remark: "",
        status: 1,
      };
    },
    getList() {
      post("/api/admin/app/wgt/list", {}).then((res) => {
        if (isSuccess(res)) {
          this.list = res.data.data || [];
        } else {
          this.$message.error(res.data.msg || "WGT 列表获取失败");
        }
      });
    },
    beforeUpload(file) {
      const ok = /\.wgt$/i.test(file.name);
      if (!ok) {
        this.$message.error("只能上传 .wgt 文件");
      }
      return ok;
    },
    uploadSuccess(res) {
      if (res.code !== 1001) {
        this.$message.error(res.msg || "上传失败");
        return;
      }
      const data = res.data || res;
      this.form.wgt_url = data.url;
      this.form.file_name = data.file_name;
      this.form.file_size = data.file_size;
      this.form.md5 = data.md5;
      this.$notify({ title: "上传成功", message: "WGT 文件信息已填入", type: "success" });
    },
    save() {
      if (!this.form.version || !this.form.version_code || !this.form.wgt_url) {
        this.$message.error("请填写版本号、版本码并上传 WGT 文件");
        return;
      }
      post("/api/admin/app/wgt/save", this.form).then((res) => {
        if (isSuccess(res)) {
          this.$notify({ title: "保存成功", message: res.data.msg, type: "success" });
          this.resetForm();
          this.getList();
        } else {
          this.$message.error(res.data.msg || "保存失败");
        }
      });
    },
    edit(row) {
      this.form = Object.assign(this.emptyForm(), row);
    },
    resetForm() {
      this.form = this.emptyForm();
    },
  },
};
</script>

<style scoped>
.app-admin-page {
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  overflow: auto;
}
.app-admin-card {
  width: 98%;
  height: 95%;
  margin: 1.5% auto;
  padding: 22px;
  background: #fff;
  box-shadow: #e0e0e0 5px 5px 10px;
  box-sizing: border-box;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 18px;
}
.title {
  color: #1f2d3d;
  font-size: 20px;
  font-weight: 700;
}
.muted {
  color: #7f8fa4;
  font-size: 12px;
}
.inline-tip {
  margin-left: 12px;
}
.publish-form {
  max-width: 860px;
  margin-bottom: 20px;
}
</style>
